const middleware = ({ store, redirect, app: { localePath } }) => {
    // If the user is authenticated redirect to home page
    if (store.getters['authentication/isAuthenticated']) {
        return redirect(localePath('index'));
    }
};
export default middleware;
